module.exports = __webpack_public_path__ + "media/images/icons/sort-descending-7e5ba0fb37ddd8ad81c854daf9cb9849.svg";